import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { paymentState } from "@/js/lists.ts";
export default {
  name: "PaymentBadgeMulti",
  props: {
    payments: {
      type: Array,
      default: []
    },
    state: String,
    date: String,
    suffix: String,
    textStyle: String,
    small: Boolean
  },
  data: function data() {
    return {
      paymentState: paymentState
    };
  },
  computed: {
    isStateShown: function isStateShown() {
      return this.state !== paymentState.DEFERRED;
    }
  },
  methods: {
    stateStyleClass: function stateStyleClass() {
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, paymentState.SUCCEEDED, "success"), paymentState.PROCESSING, "neutral"), paymentState.ACKNOWLEDGED, "neutral"), paymentState.DEFERRED, "neutral"), paymentState.FAILED, "danger");
    }
  }
};